import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Something went wrong',
  description:
    "Sorry, we couldn't locate your data. Please ensure that you have an internet connection and try again.",
  retry: 'Try Again',
})
